import { Box, Image, Text } from '@user-portal/wikr-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';

import { ERROR_LEVELS, SENTRY_CABINET } from 'services/Sentry/constants';
import { IError } from 'services/Sentry/interfaces';
import sentry from 'services/Sentry/SentryInstance';

import { CustomPrimaryButton } from 'components/Buttons';
import ContactUsLink from 'components/ContactUsLink';

import face_with_spiral_eyes from 'assets/emoji/face_with_spiral_eyes.webp';

import * as S from './styled';

const ErrorBoundary = () => {
    const { t } = useTranslation();

    const error = useRouteError();

    useEffect(() => {
        sentry.logError(error as IError, SENTRY_CABINET, ERROR_LEVELS.CRITICAL);
    }, [error]);

    return (
        <S.ErrorBoundaryWrapper>
            <Box>
                <Image center maxWidth={40} alt={t('basics.appError')} src={face_with_spiral_eyes} mb={20} />
                <Text type="h5" bold center mb={12}>
                    {t('basics.appError')}
                </Text>
                <Text color="text-secondary" center mb={32}>
                    {t('basics.appError.subTitle')}
                </Text>
                <CustomPrimaryButton onClick={() => window.location.reload()} mb={20}>
                    {t('basics.tryAgain')}
                </CustomPrimaryButton>
                <ContactUsLink subject={t('basics.errorMessage')} text="basics.contactSupport" />
            </Box>
        </S.ErrorBoundaryWrapper>
    );
};

export default ErrorBoundary;
